import { inject, Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { FeatureFlagEnum, FeatureFlagsState, FeatureFlagsStore } from '../models/feature-flag.model';
import { Observable, tap } from 'rxjs';
import { FeatureFlagEventBus } from './feature-flag-event-bus.service';

@Injectable({ providedIn: 'root' })
export class FeatureFlagStoreService extends ComponentStore<FeatureFlagsStore> {
  #featureFlagEventBus = inject(FeatureFlagEventBus);

  constructor() {
    super({ flags: <FeatureFlagsState>{} });
  }

  setFlags(flags: FeatureFlagsState): void {
    this.patchState({ flags });
  }

  getFlagByName$(name: FeatureFlagEnum): Observable<boolean> {
    return this.select(({ flags }: FeatureFlagsStore) => flags[name] ?? false).pipe(
      tap((value) => this.#featureFlagEventBus.broadcastFlagEvaluation(name, value)),
    );
  }
}
